import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { Yii } from "libraries/interfaces/Yii";

@Pipe({
    name: 'fieldConfigGetter'
})
export class FieldConfigGetterPipe implements PipeTransform {
    public transform(form: FormGroup, index: number, formControlName: string): IFieldSpecs {
        return {
            formGroup: form.get(['customFields', index]) as FormGroup,
            formControlName,
            placeholder: Yii.t('wui-sasha-js', 'Sélectionner')
        };
    }
}
